import React from 'react';
import PropTypes from 'prop-types';
import logo from './../../assets/img/logo.svg';

class Logo extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        return (
            <div className="Logo">
                <div className="svg-wrap" style={{paddingTop : '35.29411765%' }} >
                    <img src={logo} alt=""/>
                </div>
            </div>

        )
    }
}

Logo.propTypes = {
    
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/common/Logo.js